import { useEffect, useState } from 'react';

function useMapBounds(mapInstance, debounceMs = 100) {
  const [bounds, setBounds] = useState(null);

  useEffect(() => {
    if (!mapInstance) return null;

    let timeoutId = null;

    const updateBounds = () => {
      if (timeoutId) clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        const newBounds = mapInstance.getBounds();
        if (newBounds) {
          setBounds(newBounds);
        }
      }, debounceMs);
    };

    const listener = mapInstance.addListener('bounds_changed', updateBounds);

    // Initialize immediately
    updateBounds();

    return () => {
      listener.remove();
      clearTimeout(timeoutId);
    };
  }, [mapInstance, debounceMs]);

  return bounds;
}

export default useMapBounds;
